// Traducciones del onboarding (ES/EN/PT) — contenido original RapidPay

export const onboardingI18n = {
  es: {
    pageTitle: "Crea tu cuenta RapidPay",
    pageSubtitle: "Completa estos 4 pasos y nuestro equipo activará tu cuenta para que empieces a cobrar.",
    resume: { text: "Retomamos tu registro donde lo dejaste.", continue: "Continuar", reset: "Empezar de nuevo" },
    back: "Atrás",
    next: "Siguiente",
    submit: "Enviar solicitud",
    submitting: "Enviando...",
    backHome: "Volver al inicio",
    required: "Este campo es obligatorio",
    invalidEmail: "Ingresa un correo válido",
    selectOne: "Selecciona al menos una opción",
    steps: ["Negocio", "Representante", "Cobros", "Documentos", "Confirmación"],
    docs: {
      title: "Documentos requeridos",
      desc: "Sube los siguientes documentos en PDF, JPG o PNG (máx. 1.5MB cada uno).",
      items: [
        { id: "aviso_operaciones", label: "Aviso de Operaciones" },
        { id: "registro_publico", label: "Registro Público" },
        { id: "cedula_pasaporte", label: "Cédula o Pasaporte" },
        { id: "recibo_servicio", label: "Recibo de Agua o Luz" },
        { id: "carta_bancaria", label: "Carta de Certificación de Cuenta Bancaria" },
      ],
      upload: "Subir archivo",
      change: "Cambiar",
      uploading: "Subiendo...",
      uploaded: "Cargado",
      requiredAll: "Debes subir los 5 documentos requeridos",
      uploadError: "No se pudo subir el archivo. Intenta de nuevo",
      summaryLabel: "Documentos",
    },
    step1: {
      title: "Datos del negocio",
      desc: "Cuéntanos sobre tu empresa o emprendimiento.",
      name: "Nombre comercial",
      namePh: "Ej: Café Altura, S.A.",
      ruc: "RUC / Cédula jurídica",
      rucPh: "Ej: 155612345-2-2021",
      category: "Tipo de cliente",
      categoryPh: "Selecciona el tipo de cliente",
      categories: ["Emprendedor", "Pyme", "Industrias", "ONG", "Deporte"],
      website: "Sitio web o red social (opcional)",
      websitePh: "Ej: www.minegocio.com o @minegocio",
      termsPrefix: "Acepto los",
      termsLink: "términos y condiciones",
      termsRequired: "Debes aceptar los términos y condiciones",
    },
    step2: {
      title: "Datos del representante",
      desc: "La persona responsable de la cuenta.",
      fullName: "Nombre completo",
      fullNamePh: "Ej: María González",
      docId: "Cédula o pasaporte",
      docIdPh: "Ej: 8-123-4567",
      nationality: "Nacionalidad",
      nationalityPh: "Selecciona un país",
      email: "Correo electrónico",
      emailPh: "Ej: maria@minegocio.com",
      phone: "Teléfono / WhatsApp",
      phonePh: "Ej: (507) 6000-0000",
    },
    step3: {
      title: "Información de cobro",
      desc: "¿Cómo quieres cobrar a tus clientes?",
      methods: "Métodos de pago que deseas aceptar",
      methodOptions: [
        { id: "tarjetas", label: "Tarjetas Visa y Mastercard" },
        { id: "yappy", label: "Yappy" },
        { id: "ach", label: "Transferencias ACH" },
        { id: "suscripciones", label: "Cobros por suscripción" },
      ],
      volume: "Volumen estimado de ventas mensual",
      volumePh: "Selecciona un rango",
      volumeOptions: ["Menos de $1,000", "$1,000 – $5,000", "$5,000 – $20,000", "$20,000 – $50,000", "Más de $50,000"],
      bank: "Banco de Banco (CashOut)",
      bankPh: "Escribe el nombre del banco",
      bankSelectPh: "Selecciona tu banco",
      bankOther: "Otro banco (escribir)",
      accountNumber: "Número de cuenta de banco",
      accountNumberPh: "Ej: 04-01-01-123456",
      accountType: "Tipo de cuenta de banco",
      accountTypePh: "Selecciona el tipo",
      accountTypes: [{ value: "ahorro", label: "Cuenta de Ahorro" }, { value: "corriente", label: "Cuenta Corriente" }],
    },
    step4: {
      title: "Resumen y confirmación",
      desc: "Revisa tu información antes de enviar.",
      business: "Negocio",
      representative: "Representante",
      payment: "Cobros",
      termsPrefix: "He leído y acepto los",
      termsLink: "Términos y Condiciones",
      termsRequired: "Debes aceptar los Términos y Condiciones",
    },
    success: {
      title: "¡Solicitud enviada!",
      subtitle: "Tu número de referencia es",
      message: "Nuestro equipo revisará tu información y te contactará en menos de 48 horas hábiles al correo registrado para activar tu cuenta.",
      cta: "Volver al inicio",
    },
    error: "No pudimos enviar tu solicitud. Intenta de nuevo en unos minutos.",
  },
  en: {
    pageTitle: "Create your RapidPay account",
    pageSubtitle: "Complete these 4 steps and our team will activate your account so you can start getting paid.",
    resume: { text: "We picked up your registration where you left off.", continue: "Continue", reset: "Start over" },
    back: "Back",
    next: "Next",
    submit: "Submit application",
    submitting: "Submitting...",
    backHome: "Back to home",
    required: "This field is required",
    invalidEmail: "Enter a valid email",
    selectOne: "Select at least one option",
    steps: ["Business", "Representative", "Payments", "Documents", "Confirmation"],
    docs: {
      title: "Required documents",
      desc: "Upload the following documents in PDF, JPG or PNG (max. 1.5MB each).",
      items: [
        { id: "aviso_operaciones", label: "Operations Notice (Aviso de Operaciones)" },
        { id: "registro_publico", label: "Public Registry certificate" },
        { id: "cedula_pasaporte", label: "ID or Passport" },
        { id: "recibo_servicio", label: "Water or Electricity bill" },
        { id: "carta_bancaria", label: "Bank Account Certification Letter" },
      ],
      upload: "Upload file",
      change: "Change",
      uploading: "Uploading...",
      uploaded: "Uploaded",
      requiredAll: "You must upload all 5 required documents",
      uploadError: "The file could not be uploaded. Please try again",
      summaryLabel: "Documents",
    },
    step1: {
      title: "Business details",
      desc: "Tell us about your company or venture.",
      name: "Business name",
      namePh: "E.g.: Café Altura, S.A.",
      ruc: "Tax ID (RUC)",
      rucPh: "E.g.: 155612345-2-2021",
      category: "Client type",
      categoryPh: "Select the client type",
      categories: ["Entrepreneur", "SME", "Industries", "NGO", "Sports"],
      website: "Website or social media (optional)",
      websitePh: "E.g.: www.mybusiness.com or @mybusiness",
      termsPrefix: "I accept the",
      termsLink: "terms and conditions",
      termsRequired: "You must accept the terms and conditions",
    },
    step2: {
      title: "Representative details",
      desc: "The person responsible for the account.",
      fullName: "Full name",
      fullNamePh: "E.g.: María González",
      docId: "ID or passport",
      docIdPh: "E.g.: 8-123-4567",
      nationality: "Nationality",
      nationalityPh: "Select a country",
      email: "Email address",
      emailPh: "E.g.: maria@mybusiness.com",
      phone: "Phone / WhatsApp",
      phonePh: "E.g.: (507) 6000-0000",
    },
    step3: {
      title: "Payment information",
      desc: "How do you want to charge your customers?",
      methods: "Payment methods you want to accept",
      methodOptions: [
        { id: "tarjetas", label: "Visa and Mastercard cards" },
        { id: "yappy", label: "Yappy" },
        { id: "ach", label: "ACH transfers" },
        { id: "suscripciones", label: "Subscription billing" },
      ],
      volume: "Estimated monthly sales volume",
      volumePh: "Select a range",
      volumeOptions: ["Less than $1,000", "$1,000 – $5,000", "$5,000 – $20,000", "$20,000 – $50,000", "More than $50,000"],
      bank: "Banco de Banco (CashOut)",
      bankPh: "Type the bank name",
      bankSelectPh: "Select your bank",
      bankOther: "Other bank (type it)",
      accountNumber: "Bank account number",
      accountNumberPh: "E.g.: 04-01-01-123456",
      accountType: "Bank account type",
      accountTypePh: "Select a type",
      accountTypes: [{ value: "ahorro", label: "Savings account" }, { value: "corriente", label: "Checking account" }],
    },
    step4: {
      title: "Summary & confirmation",
      desc: "Review your information before submitting.",
      business: "Business",
      representative: "Representative",
      payment: "Payments",
      termsPrefix: "I have read and accept the",
      termsLink: "Terms and Conditions",
      termsRequired: "You must accept the Terms and Conditions",
    },
    success: {
      title: "Application submitted!",
      subtitle: "Your reference number is",
      message: "Our team will review your information and contact you within 48 business hours at your registered email to activate your account.",
      cta: "Back to home",
    },
    error: "We couldn't submit your application. Please try again in a few minutes.",
  },
  pt: {
    pageTitle: "Crie sua conta RapidPay",
    pageSubtitle: "Complete estes 4 passos e nossa equipe ativará sua conta para você começar a receber.",
    resume: { text: "Retomamos seu cadastro de onde você parou.", continue: "Continuar", reset: "Começar de novo" },
    back: "Voltar",
    next: "Próximo",
    submit: "Enviar solicitação",
    submitting: "Enviando...",
    backHome: "Voltar ao início",
    required: "Este campo é obrigatório",
    invalidEmail: "Digite um e-mail válido",
    selectOne: "Selecione pelo menos uma opção",
    steps: ["Negócio", "Representante", "Recebimentos", "Documentos", "Confirmação"],
    docs: {
      title: "Documentos obrigatórios",
      desc: "Envie os seguintes documentos em PDF, JPG ou PNG (máx. 1.5MB cada).",
      items: [
        { id: "aviso_operaciones", label: "Aviso de Operações" },
        { id: "registro_publico", label: "Registro Público" },
        { id: "cedula_pasaporte", label: "Documento ou Passaporte" },
        { id: "recibo_servicio", label: "Conta de Água ou Luz" },
        { id: "carta_bancaria", label: "Carta de Certificação de Conta Bancária" },
      ],
      upload: "Enviar arquivo",
      change: "Trocar",
      uploading: "Enviando...",
      uploaded: "Enviado",
      requiredAll: "Você deve enviar os 5 documentos obrigatórios",
      uploadError: "Não foi possível enviar o arquivo. Tente novamente",
      summaryLabel: "Documentos",
    },
    step1: {
      title: "Dados do negócio",
      desc: "Conte-nos sobre sua empresa ou empreendimento.",
      name: "Nome comercial",
      namePh: "Ex: Café Altura, S.A.",
      ruc: "RUC / CNPJ",
      rucPh: "Ex: 155612345-2-2021",
      category: "Tipo de cliente",
      categoryPh: "Selecione o tipo de cliente",
      categories: ["Empreendedor", "PME", "Indústrias", "ONG", "Esporte"],
      website: "Site ou rede social (opcional)",
      websitePh: "Ex: www.meunegocio.com ou @meunegocio",
      termsPrefix: "Aceito os",
      termsLink: "termos e condições",
      termsRequired: "Você deve aceitar os termos e condições",
    },
    step2: {
      title: "Dados do representante",
      desc: "A pessoa responsável pela conta.",
      fullName: "Nome completo",
      fullNamePh: "Ex: María González",
      docId: "Documento ou passaporte",
      docIdPh: "Ex: 8-123-4567",
      nationality: "Nacionalidade",
      nationalityPh: "Selecione um país",
      email: "E-mail",
      emailPh: "Ex: maria@meunegocio.com",
      phone: "Telefone / WhatsApp",
      phonePh: "Ex: (507) 6000-0000",
    },
    step3: {
      title: "Informações de recebimento",
      desc: "Como você quer cobrar seus clientes?",
      methods: "Métodos de pagamento que deseja aceitar",
      methodOptions: [
        { id: "tarjetas", label: "Cartões Visa e Mastercard" },
        { id: "yappy", label: "Yappy" },
        { id: "ach", label: "Transferências ACH" },
        { id: "suscripciones", label: "Cobrança por assinatura" },
      ],
      volume: "Volume estimado de vendas mensal",
      volumePh: "Selecione uma faixa",
      volumeOptions: ["Menos de $1,000", "$1,000 – $5,000", "$5,000 – $20,000", "$20,000 – $50,000", "Mais de $50,000"],
      bank: "Banco de Banco (CashOut)",
      bankPh: "Digite o nome do banco",
      bankSelectPh: "Selecione seu banco",
      bankOther: "Outro banco (digitar)",
      accountNumber: "Número da conta bancária",
      accountNumberPh: "Ex: 04-01-01-123456",
      accountType: "Tipo de conta bancária",
      accountTypePh: "Selecione o tipo",
      accountTypes: [{ value: "ahorro", label: "Conta Poupança" }, { value: "corriente", label: "Conta Corrente" }],
    },
    step4: {
      title: "Resumo e confirmação",
      desc: "Revise suas informações antes de enviar.",
      business: "Negócio",
      representative: "Representante",
      payment: "Recebimentos",
      termsPrefix: "Li e aceito os",
      termsLink: "Termos e Condições",
      termsRequired: "Você deve aceitar os Termos e Condições",
    },
    success: {
      title: "Solicitação enviada!",
      subtitle: "Seu número de referência é",
      message: "Nossa equipe revisará suas informações e entrará em contato em até 48 horas úteis no e-mail cadastrado para ativar sua conta.",
      cta: "Voltar ao início",
    },
    error: "Não foi possível enviar sua solicitação. Tente novamente em alguns minutos.",
  },
};
